import type {TooltipProps as ChakraTooltipProps} from '@chakra-ui/react';
import {forwardRef, Tooltip as ChakraTooltip} from '@chakra-ui/react';

export type TooltipProps = ChakraTooltipProps;

export const Tooltip = forwardRef<TooltipProps, 'div'>(({children, ...props}, ref) => {
  return (
    <ChakraTooltip hasArrow ref={ref} {...props}>
      <span style={{display: `inline-block`}}>{children}</span>
    </ChakraTooltip>
  );
});
